"use client";

import { createContext, useContext } from "react";
import type { FeatureTab } from "../types";

/**
 * Navegação de dentro da tela replicada. O menu lateral da demo deixa de ser
 * enfeite: clicar num item troca a sessão, como trocar de aba na fileira de
 * baixo. Sem provider a demo fica só olhando, como era antes.
 */
export const DemoNavContext = createContext<{
  onNavigate?: (tab: FeatureTab) => void;
}>({});

export function useDemoNav() {
  return useContext(DemoNavContext);
}
